/**
 * /producao/* — router-shell do módulo Produção v2 (BRIEF DEFINITIVO Fase 4).
 *
 * Sprint P5: todas as telas do módulo são reais:
 *
 *   /producao                    Painel de Produção (board por etapa) — REAL
 *   /producao/ambientes/:id      Detalhe do Ambiente — REAL
 *   /producao/pedidos/:id        Detalhe do Pedido (agregador, versão mínima)
 *   /producao/lotes/:id          Detalhe do Lote — REAL
 *   /producao/otimizacao         Otimização & Lotes — REAL
 *   /producao/marcenaria         Planejamento Marcenaria — REAL
 *   /producao/dbr                KPIs PPCP (DBR) — REAL
 *   /producao/atrasos            Análise de Atrasos (Ishikawa) — REAL
 *   /producao/config             Configurações da Produção — REAL
 *
 * As telas antigas /producao/ordens/* e /producao/toc foram REMOVIDAS no P5
 * (zero coexistência) — URLs antigas caem no catch-all e voltam a /producao.
 * /producao/terminal/* segue fora do shell autenticado.
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import AnaliseAtrasos from "./AnaliseAtrasos";
import Config from "./Config";
import Dbr from "./Dbr";
import DetalheAmbiente from "./DetalheAmbiente";
import DetalheLote from "./DetalheLote";
import DetalhePedidoProducao from "./DetalhePedidoProducao";
import Disposicao from "./Disposicao";
import Marcenaria from "./Marcenaria";
import MinhasEtapas from "./MinhasEtapas";
import Otimizacao from "./Otimizacao";
import Painel from "./Painel";

import { useAuth } from "../../context/AuthContext";
import { PageState } from "../../styles/shared";

/**
 * A17: o item "Operadores PIN" da sidebar pede `operador:view` e leva a
 * /producao/config, mas o modulo inteiro so abria com
 * `ambiente_producao:view` — quem administra PIN via o menu e levava
 * "sem permissao" no clique, e o operador bloqueado por errar a senha
 * ficava parado ate aparecer um Master. O shell passa a aceitar as duas
 * permissoes e cada tela de chao se protege aqui dentro.
 */
function ExigeProducao({ children }) {
  const { hasAllPermissions, isMaster } = useAuth();
  if (isMaster || hasAllPermissions(["ambiente_producao:view"])) return children;
  return (
    <PageState $tone="error">
      Você não tem permissão para acessar esta página.
    </PageState>
  );
}

export default function ProducaoV2Shell() {
  const { hasAllPermissions, isMaster } = useAuth();
  const veProducao = isMaster || hasAllPermissions(["ambiente_producao:view"]);
  return (
    <Routes>
      <Route
        index
        element={veProducao ? <Painel /> : <Navigate to="/producao/config" replace />}
      />
      <Route path="ambientes/:id" element={<ExigeProducao><DetalheAmbiente /></ExigeProducao>} />
      <Route path="pedidos/:id" element={<ExigeProducao><DetalhePedidoProducao /></ExigeProducao>} />
      <Route path="lotes/:id" element={<ExigeProducao><DetalheLote /></ExigeProducao>} />
      <Route path="minhas-etapas" element={<ExigeProducao><MinhasEtapas /></ExigeProducao>} />
      <Route path="otimizacao" element={<ExigeProducao><Otimizacao /></ExigeProducao>} />
      <Route path="marcenaria" element={<ExigeProducao><Marcenaria /></ExigeProducao>} />
      <Route path="disposicao" element={<ExigeProducao><Disposicao /></ExigeProducao>} />
      <Route path="dbr" element={<ExigeProducao><Dbr /></ExigeProducao>} />
      <Route path="atrasos" element={<ExigeProducao><AnaliseAtrasos /></ExigeProducao>} />
      <Route path="config" element={<Config />} />
      <Route path="*" element={<Navigate to={veProducao ? "/producao" : "/producao/config"} replace />} />
    </Routes>
  );
}
